module.exports = __webpack_public_path__ + "static/media/Logo-Banamex.674d7a75.svg";